import React from 'react';
import {
  Button,
  Drawer,
  Form,
  Image,
  Input,
  Select,
  Table,
  Upload,
} from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { RiShip2Line } from '@remixicon/react';
import styled from 'styled-components';

export const CompanyMobilePage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  box-sizing: border-box;
  width: calc(100% + 32px);
  max-width: none;
  margin: 0 -16px;
  padding: 0 20px 24px;
  overflow-x: hidden;
  background: #ffffff;
`;

export const CompanyMobileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: calc(100% + 40px);
  min-height: 56px;
  margin: 0 -20px;
  padding: 12px 20px;
  border-bottom: 1px solid #d9d9d9;
  background: #ffffff;
`;

export const CompanyMobileHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 12px;
`;

export const CompanyMobileBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #111827;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const CompanyMobileHeaderCopy = styled.div`
  min-width: 0;

  h1 {
    width: 120px;
    margin: 0;
    overflow: hidden;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CompanyMobileHeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
`;

export const CompanyMobileActionButton = styled(Button)`
  && {
    min-width: 73px;
    height: 32px;
    padding: 6px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }
`;

export const CompanyMobileSecondaryButton = styled(Button)`
  && {
    min-width: 86px;
    height: 32px;
    padding: 6px 20px;
    border-color: #d9d9d9;
    border-radius: 6px;
    background: #ffffff;
    color: #595959;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }
`;

export const CompanyMobileIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: #264284;
  color: #ffffff;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const CompanyMobileFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const CompanyMobileSearch = styled(Input)`
  &&,
  &&.ant-input-affix-wrapper {
    flex: 1 1 auto;
    min-width: 0;
    height: 44px;
    padding: 0 10px;
    border-color: #e8ecf3;
    border-radius: 6px;
    background: #ffffff;
    color: #1e1e1e;
    font-size: 14px;
  }

  && .ant-input {
    height: 42px;
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    color: #1e1e1e;
    font-size: 14px;
    line-height: 22px;
  }

  && .ant-input::placeholder {
    color: #bfbfbf;
  }

  && .ant-input-suffix {
    margin-inline-start: 10px;
    color: #9facbf;
    font-size: 24px;
  }

  && .ant-input-suffix svg {
    width: 24px;
    height: 24px;
  }
`;

export const CompanyMobileFilterButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid #e8ecf3;
  border-radius: 6px;
  background: #ffffff;
  color: #1e1e1e;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const CompanyMobileTableCard = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background: #ffffff;

  .ant-table-wrapper,
  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table,
  .ant-table-container,
  .ant-table-content,
  table {
    width: 1150px !important;
    min-width: 1150px !important;
  }

  .ant-table {
    font-size: 12px;
  }

  .ant-table-thead > tr,
  .ant-table-tbody > tr {
    box-shadow: inset 0 -1px 0 #e8ecf3;
  }

  .ant-table-thead > tr > th {
    height: 46px;
    padding: 12px;
    box-sizing: border-box;
    border-right: 1px solid #d9d9d9;
    border-bottom: 0;
    background: #fafafa;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th:last-child {
    border-right: 0;
  }

  .ant-table-tbody > tr > td {
    height: 48px;
    padding: 16px 12px;
    box-sizing: border-box;
    border-bottom: 0;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-tag {
    margin-inline-end: 0;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .ant-image-img {
    object-fit: contain;
  }
`;

export const CompanyMobilePagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 40px;
`;

export const CompanyMobilePaginationInfo = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #9facbf;
  font-size: 12px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CompanyMobilePaginationActions = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 6px;
  height: 40px;
`;

export const CompanyMobilePageButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  flex: 0 0 32px;
  padding: 0;
  border: 1px solid ${(props) => (props.$active ? '#272a35' : '#e8ecf3')};
  border-radius: 4px;
  background: #ffffff;
  color: ${(props) => (props.disabled ? '#c5cddb' : '#1e1e1e')};
  font-size: 14px;
  line-height: 22px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const CompanyMobileFilterDrawer = styled(Drawer)`
  &&.ant-drawer-bottom > .ant-drawer-content-wrapper {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }

  .ant-drawer-content {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    background: #ffffff;
  }

  .ant-drawer-header {
    padding: 16px 12px;
    border-bottom: 1px solid #e8ecf3;
  }

  .ant-drawer-header-title {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .ant-drawer-title {
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .ant-drawer-close {
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
    color: #1e1e1e;
  }

  .ant-drawer-body {
    padding: 0 0 12px;
  }
`;

export const CompanyMobileFilterForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const CompanyMobileFilterFields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 12px;
`;

export const CompanyMobileFilterField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  color: #768499;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;

export const CompanyMobileFilterSelect = styled(Select)`
  && {
    width: 100%;
  }

  && .ant-select-selector {
    height: 44px !important;
    padding: 0 8px !important;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
  }

  && .ant-select-selection-item {
    color: #1e1e1e;
    font-size: 12px;
    font-weight: 400;
    line-height: 42px !important;
  }

  && .ant-select-arrow {
    right: 8px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    color: #9facbf;
    font-size: 14px;
    line-height: 24px;
  }

  && .ant-select-arrow svg {
    width: 14px;
    height: 14px;
  }
`;

export const CompanyMobileFilterActions = styled.div`
  display: flex;
  width: 100%;
  padding: 0 20px;
`;

export const CompanyMobileFilterApplyButton = styled(Button)`
  && {
    width: 100%;
    height: 44px;
    border: 0;
    border-radius: 6px;
    background: #264284;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
  }

  &&:hover,
  &&:focus {
    background: #264284;
    color: #ffffff;
  }
`;

export const CompanyMobileForm = styled.div`
  width: 100%;
  padding: 12px 0 24px;
`;

export const CompanyMobileSection = styled.section<{ $bordered?: boolean }>`
  width: 100%;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: ${(props) => (props.$bordered ? '1px solid #d9d9d9' : '0')};
`;

export const CompanyMobileSectionHeader = styled.div`
  margin-bottom: 8px;

  h2 {
    margin: 0;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    margin: 2px 0 0;
    color: #768499;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const CompanyMobileField = styled(Form.Item)`
  && {
    width: 100%;
    margin: 0 0 8px;
  }

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-label > label {
    height: auto;
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .ant-form-item-label > label.ant-form-item-required::before {
    color: #ff3a3a;
  }

  .ant-input,
  .ant-select-selector {
    min-height: 44px;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    font-size: 12px;
  }

  .ant-select-selector {
    height: 44px !important;
    display: flex;
    align-items: center;
    padding: 0 10px !important;
  }

  .ant-select-selection-search {
    inset-inline-start: 10px !important;
    inset-inline-end: 32px !important;
  }

  .ant-select-selection-search-input {
    height: 42px !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
    height: 42px;
    line-height: 1.2 !important;
  }

  .ant-input::placeholder,
  .ant-select-selection-placeholder {
    color: #bfbfbf;
    font-size: 12px;
  }

  .ant-select-arrow {
    color: #9facbf;
    font-size: 14px;
  }
`;

export const CompanyMobileSwitchGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 20px;
`;

export const CompanyMobileSwitchField = styled(CompanyMobileField)`
  && {
    margin-bottom: 0;
  }

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-control-input {
    min-height: 22px;
  }

  .ant-switch {
    min-width: 44px;
    height: 22px;
  }

  .ant-switch-handle {
    width: 18px;
    height: 18px;
  }

  .ant-switch-checked .ant-switch-handle {
    inset-inline-start: calc(100% - 20px);
  }
`;

export const CompanyMobileDetailRows = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  width: 100%;
`;

export const CompanyMobileDetailRow = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  min-width: 0;
  grid-column: ${(props) => (props.$fullWidth ? '1 / -1' : 'auto')};
`;

export const CompanyMobileDetailLabel = styled.span`
  width: 100%;
  color: #768499;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
`;

export const CompanyMobileDetailValue = styled.div`
  width: 100%;
  min-width: 0;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  text-align: left;
  word-break: break-word;
  overflow-wrap: anywhere;

  .ant-tag {
    margin: 0;
    padding: 0 8px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`;

export const CompanyMobileDetailSection = styled.section<{
  $bordered?: boolean;
}>`
  width: 100%;
  margin-bottom: 12px;
  padding-bottom: 24px;
  border-bottom: ${(props) => (props.$bordered ? '1px solid #d9d9d9' : '0')};
`;

export const CompanyMobileDetailSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;

  h2 {
    margin: 0;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    margin: 0;
    color: #768499;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
  }
`;

export const CompanyMobileAlert = styled.div`
  margin-bottom: 12px;
`;

export const CompanyMobileDataTable = styled(Table)`
  width: 100%;

  .ant-table-container {
    overflow: hidden;
    border-radius: 12px 12px 0 0;
  }

  .ant-table-content table {
    min-width: 760px;
  }

  && .ant-table-thead > tr > th {
    height: 46px;
    padding: 12px;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background: #fafafa;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    white-space: nowrap;
  }

  && .ant-table-thead > tr > th:last-child {
    border-right: 0;
  }

  && .ant-table-tbody > tr > td {
    height: 48px;
    padding: 16px 12px;
    border-bottom: 1px solid #e8ecf3;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-tag {
    margin: 0;
    padding: 0 8px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .ant-image-img {
    object-fit: contain;
  }
`;

export const CompanyMobileImagePreview = styled(Image)<{ $height?: number }>`
  && {
    width: 100%;
    height: ${(props) => props.$height ?? 180}px;
    display: block;
    object-fit: contain;
    background: #f5f6f9;
  }

  .ant-image-img {
    width: 100%;
    height: ${(props) => props.$height ?? 180}px;
    object-fit: contain;
    background: #f5f6f9;
  }
`;

export const CompanyMobileImageSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
`;

export const CompanyMobileEmptyImagePreview = styled.div<{ $height?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: ${(props) => props.$height ?? 180}px;
  background: #f5f6f9;
  text-align: center;

  svg {
    width: 48px;
    height: 48px;
    color: #a0aabd;
  }

  .empty-title {
    margin: 0;
    color: #a0aabd;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0;
  }

  .empty-description {
    margin: 5px 0 0;
    color: #a1abbe;
    font-size: 10px;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.2px;
  }
`;

export const CompanyMobileUploadPanel = styled(Upload)`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  background: #f0f0f0;

  .upload-info {
    flex: 1 1 auto;
    min-width: 0;
    color: #000000;
    font-size: 8px;
    line-height: 1.2;
  }

  .ant-upload {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .ant-upload > span {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .ant-btn {
    flex: 0 0 139px;
    width: 139px;
    height: 40px;
    padding: 8px 12px;
    border-color: #d9d9d9;
    border-radius: 6px;
    color: #000000;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const CompanyMobileNoImagePreview = ({ height }: { height?: number }) => (
  <CompanyMobileEmptyImagePreview $height={height}>
    <RiShip2Line />
    <div>
      <p className="empty-title">No Image Available</p>
      <p className="empty-description">Upload your asset image</p>
    </div>
  </CompanyMobileEmptyImagePreview>
);

type MobileHeaderProps = {
  title: string;
  onBack?: () => void;
  action?: React.ReactNode;
};

export const MobileCompanyHeader = ({
  title,
  onBack,
  action,
}: MobileHeaderProps) => (
  <CompanyMobileHeader>
    <CompanyMobileHeaderLeft>
      {onBack ? (
        <CompanyMobileBackButton
          type="button"
          onClick={onBack}
          aria-label="Back"
        >
          <LeftOutlined />
        </CompanyMobileBackButton>
      ) : null}
      <CompanyMobileHeaderCopy>
        <h1>{title}</h1>
      </CompanyMobileHeaderCopy>
    </CompanyMobileHeaderLeft>
    {action}
  </CompanyMobileHeader>
);
